import deep_canvassing from './deep_canvassing.json';
import glapp from './glapp.json';
import nl from './nl.json';

export default {
  deep_canvassing,
  glapp,
  nl,
} as Record<string, any>;
